module.exports = __webpack_public_path__ + "img/google-reviews.63b515be.jpg";